import { Observable, Subject } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';

import { createObservableAndState, ObservableAndState } from './observable_and_state';

export type StateSelectorFunction<T, K> = (state: T) => K;

export const createStateSelector = <T, K>(
  storeSubject: Subject<T>,
  currentState: T,
  selectorFct: StateSelectorFunction<T, K>,
): ObservableAndState<K> => {
  return createObservableAndState(
    storeSubject.pipe(map(selectorFct), distinctUntilChanged()),
    selectorFct(currentState),
  );
};
export const createObservableSelector = <T, K>(
  storeSubject: Subject<T>,
  selectorFct: StateSelectorFunction<T, K>,
): Observable<K> => {
  return storeSubject.pipe(map(selectorFct), distinctUntilChanged());
};
